import React from 'react';
import {
  TradingScoreDataContent,
  TRADING_SCORE_LABELS,
  TRADING_SCORE_STYLES,
} from './types';

interface TradingScoreSummaryProps {
  data: unknown;
  config: Record<string, unknown>;
}

const TradingScoreSummary: React.FC<TradingScoreSummaryProps> = ({ data }) => {
  const content = data as TradingScoreDataContent | undefined;
  const action = content?.action;

  if (!action) {
    return <span className="text-neutral-300">—</span>;
  }

  const styles = TRADING_SCORE_STYLES[action];

  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-bold ${styles.badge}`}>
      {TRADING_SCORE_LABELS[action] ?? action}
    </span>
  );
};

export default TradingScoreSummary;
